import { OccupancyEnum } from "@gtpl/shared-models/masters";
import { Column, Entity,  PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn, Unique } from "typeorm";

@Entity('pallet')
export class Pallet {

  @PrimaryGeneratedColumn("increment", { name: 'pallet_id' })
  palletId: number;

  @Unique('palletNo',["palletNo"])
  @Column('varchar', {
    nullable: false,
    length:30,
    name: 'pallet_no'
  })
  palletNo: string;  
  @Column('varchar', {
    nullable: false,
    length:30,
    name: 'pallet_code'
  })
  palletCode: string;  

  @Column("text", {
    nullable: false,
    name: "assoc_rfid"
  })
  assocRfId: string;

  @Column('integer', {
    nullable: false,
    name: 'plant_id'
  })
  plantId: number;

  @Column({
    type: 'enum',
    enum: OccupancyEnum,
    nullable: false,
    default: OccupancyEnum.NOT_OCCUPIED,
    name: 'occupancy'
  })
  occupancy: OccupancyEnum;

  @Column("boolean", {
    nullable: false,
    name: "is_active",
    default:true
  })
  isActive: boolean | null;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    length: 50
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 50
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

}
